<template>
    <div v-bind:class="['alert', 'alert-' + type, 'break-word']" role="alert" class="alert-block">

        <!-- string -->
        <template v-if="typeof error === 'string'">
            {{ error }}
        </template>
        <!-- Axios error object -->
        <template v-else-if="error &&
                        error.response &&
                        error.response.data">

            <!-- Returned validation errors -->
            <template v-if="error.response.data.errors">
                Please fix the following validation issues:
                <ul>
                    <template v-for="(issues, key) in error.response.data.errors">
                        <li v-for="issue in issues">{{ issue }}</li>
                    </template>
                </ul>
            </template>
            <!-- Returned message -->
            <template v-else-if="error.response.data.error">
                {{ error.response.data.error }}
            </template>
            <!-- Returned message -->
            <template v-else-if="error.response.data.message">
                <template v-if="error.response.data.message == 'invalid_credentials'">
                    Invalid username or password
                </template>
                <template v-else>
                    {{ error.response.data.message }}
                </template>
            </template>
            <!-- HTTP call failed -->
            <template v-else>HTTP call failed</template>

        </template>
        <!-- JS error object -->
        <template v-else-if="error && error.message">
            {{ error.message }}
        </template>
        <!-- No HTTP error, use supplied message -->
        <span v-else>

            <template v-if="message">{{ message }}</template>
            <template v-else>No status message supplied</template>

            <!-- Add internal link if supplied -->
            <router-link v-if="link"
                         v-bind:to="{ path: link.path }">
                {{ link.text }}
            </router-link>

            <!-- Add external link if supplied -->
            <a  v-if="linkExternal"
                v-bind:href="linkExternal.path"
                v-bind:target="linkExternal.new_tab ? '_blank' : ''">
                {{ linkExternal.text }}
            </a>

        </span>
    </div>
</template>

<script>
export default {

    props : ['type', 'message', 'error', 'link', 'linkExternal'],

    mounted() {
        console.log('alert error', this.error)
    },

    data () {
        return {

        }
    },

    watch: {
        error: function(){
            console.log('alert error', this.error)
        }
    }
}
</script>

<style scoped>
.alert-block{
    font-size: 18px;
    color:#1F303F;
}
</style>


// WEBPACK FOOTER //
// src/js/components/fragments/alert.vue